import React from 'react';
import closeIcon from '../../../images/close popup.png';
import '../Style/warningToggle.css';
import {ICONS} from '../Config/WarningToggle.constants';

const WarningToggleSmall = ({className, title, close, color = 'blue'}) => (
    <div className={`${className} small-warning small-warning-${color}`}>
        <img alt='warning icon' src={ICONS[color]} className='red-warning-img' />
        <p className='small-warning-p'>{title}</p>
        {close && <img className='close-toggle' src={closeIcon} alt='close popup' onClick={close}/>}
    </div>
);

export default WarningToggleSmall;
